<template>
  <div data-component="base-content-loader">
    <div class="content">
      <div
        v-if="title"
        class="title"
      >
        {{ title }}
      </div>

      <or-loader
        v-if="!$slots.actions"
        :variant="variant"
      />

      <div
        v-if="description"
        class="description"
      >
        {{ description }}
      </div>

      <slot name="actions" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';
import type { TranslateResult } from 'vue-i18n';
import { OrLoaderV3 as OrLoader } from '@onereach/ui-components-25';

export default defineComponent({
  name: 'BaseContentLoader',
  components: { OrLoader },
  props: {
    title: {
      type: String as PropType<string | TranslateResult>,
      default: '',
    },
    description: {
      type: String as PropType<string | TranslateResult>,
      default: '',
    },
    variant: {
      type: String as PropType<'linear' | 'circular'>,
      default: 'linear',
    },
  },
});
</script>

<style lang="scss" scoped>
[data-component='base-content-loader'] {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  width: 100%;
  padding: var(--s-4);

  .content {
    display: flex;
    flex-direction: column;
    gap: var(--s-4);
    text-align: center;
    width: 100%;
    max-width: 22.5rem;
  }

  .title {
    color: var(--or-c-on-background);
    font-size: var(--fs-2);
    font-weight: var(--fw-2);
    word-break: break-word;
  }

  .description {
    color: var(--or-c-outline);
    word-break: break-word;
  }
}
</style>
